import { Action } from 'redux';
import _ from 'underscore';

import { isRemoveAlertAction } from '../actions/RemoveAlertAction';
import { isUpdateAlertsAction } from '../actions/UpdateAlertsAction';
import { isUpdateAlertTotalAction } from '../actions/UpdateAlertTotalAction';
import { AlertListInfoState } from '../state/AlertListInfoState';

const initialState: AlertListInfoState = {
  alerts: null,
  total: 0
};

export function alertListInfoReducer(
  alertListInfo: AlertListInfoState = initialState,
  action: Action = null
): AlertListInfoState {
  if (isRemoveAlertAction(action)) {
    if (!alertListInfo.alerts) {
      return alertListInfo;
    }

    const remainingAlerts = _.filter(alertListInfo.alerts, (alert) => alert.id !== action.alertId);
    const numberRemoved = alertListInfo.alerts.length - remainingAlerts.length;

    if (numberRemoved === 0) {
      return alertListInfo;
    } else {
      return {
        alerts: remainingAlerts,
        total: alertListInfo.total - numberRemoved
      };
    }

  } else if (isUpdateAlertsAction(action)) {
    return {
      alerts: action.alerts,
      total: action.total
    };
  } else if (isUpdateAlertTotalAction(action)) {
    return {
      alerts: alertListInfo.alerts,
      total: action.total
    };
  } else {
    return alertListInfo;
  }
}
